<template>
  <main class="skillset">
    <div id="topBlur" :style="{background:`linear-gradient(${avrgColor}dd, transparent)`}"></div>

    <h1 id="pTop">Programming ability</h1>

    <div class="spinerParent" v-if="loading">
      <img src="../assets/spin.png" />
    </div>

    <section id="skillContainer" v-if="!loading">
      <!-- Your app content goes here -->  
      <div id="sticky" v-if="ability && !fetchErr">
        <div>
          <img id="themeImg" :src="ability.icon" @load="applyThematicColor()" />
          <h2>{{ability.title}}</h2>
        </div>
        <p>{{ability.shortDesc}}</p>
      </div>

      <div class="ablityShow" v-if="ability && !fetchErr" id="xp">

        <div class="longExp">

          <p v-for="(content, i) in ability.longDesc" :key="i">
            {{content}}
          </p>

        </div>

      </div>

      <div class="tooling" v-if="!loadingSkill && !fetchErr">
        <h2>My development set:</h2>

        <div class="toolcont">
          <div class="ecosys" v-for="(langKey, i) in ability.coll" :key="i">

            <div class="header">
              <img :src="langFilter(langKey)[0]" />
              <h3>{{langFilter(langKey)[1]}}</h3>
            </div>

            <div class="body">
              <p>{{langFilter(langKey)[2] ? langFilter(langKey)[2] : 'Nothing to say'}}</p>
              
              <div class="tools">

                <div v-for="(tool, i) in toolFilter(langKey)" :key="i" class="tools_tool" :data-desc="tool[2]">
                  <img :src="tool[0]" />
                  <p>{{tool[1]}}</p>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="projects" v-if="projects.length">
          <h2 v-if="projects.length > 0">Related projects</h2>
          <h2 v-else>No related projects</h2>

          <div class="slidePosition" ref="positions">
            <span v-for="i in projects.length" :key="i" :class="`sp-${i-1}`"></span>
          </div>

          <div class="sliderCont">
            <div class="pointer p1">
              <span @click="slideStep(-1, 'animteLeftToRight', $event)" :style="{ opacity: slidePos <= 0 ? '0' : '1' }">&#60;</span>
            </div>

            <div class="slide" ref="slideCnt">
              <ProjectLite v-for="(project, i) in projects" :key="i" :projectData="project" :tools="skillset" :class="`prj prj-${i}`" />
            </div>

            <div class="pointer p2">
              <span @click="slideStep(1, 'animteRightToLeft', $event)" :style="{ opacity: slidePos < projects.length -1 ? '1' : '0' }">&#62;</span>
            </div>
          </div>

        </div>

      </div>

      <fetchError @ready="catchReady($event)" :style="{display:fetchErr?'flex':'none'}" :Exception="fetchErr" />
      
    </section>

  </main>
</template>
  
<script lang="js">
  import Request from "../mixins/axiosRequest";
  import * as timeago from "timeago.js";
  import fetchError from "../components/Small/fetchError.vue";
  import ProjectLite from "../components/Small/ProjectLite.vue";
  import colorPalette from "../mixins/colorPaletteExtraction.js";
  import queryPalette from "../mixins/themeColor.js";

  export default {
    name: "Skill_Set",
    title: "Details - Nethanzêl's Showroom",
    components: {
      fetchError,
      ProjectLite
    },
  
    data() {
      return {
        ability: null,
        loading: true,
        loadingSkill: true,
        avrgColor: undefined,
        fetchErr: null,
        skillset: {},
        projects: [],
        slidePos: 0
      };
    },
  
    methods: {
      async getAbility() {
        let projRef = this.$router.currentRoute.params.query;
        let data = await Request.axiosGet(`/api/ability/${projRef}`, this.client);
        if(data.status) {
          this.ability = data.data[0];
          this.getProjectsByTool(data.data[0].coll, "projects");
        } else {
          this.fetchErr = data.data;
          this.meshApply();
        }
        this.loading = false;
      },
      async getSkillByPart(part,setTo) {
        let data = await Request.axiosGet(`/api/skills/${part}`, this.client);
        if(data.status) {
          this[setTo] = data.data;
        }
        this.loadingSkill = false;
      },
      async getProjectsByTool(part, setTo) {
        let data = await Request.axiosGet(`/api/projectfilter?filter=${part.toString()}`, this.client);
        if(data.status) {
          this[setTo] = data.data.records;
          setTimeout(() => this.initSlide(), 500);
        }
        this.loadingSkill = false;
      },
      dateFormat(raw) {
        return timeago.format(raw);
      },
      applyThematicColor() {
        setTimeout(() => {
          document.querySelector("#topBlur").style.opacity = 0;

          colorPalette.extract("themeImg").then(Palette => {
            
            this.avrgColor = Palette[0][Math.floor(Palette[0].length / 2)];
            document.querySelector("#topBlur").style.opacity =.7;

            let gradient = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%),
                            radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%),
                            radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`

            document.querySelector("#skillContainer").style.backgroundImage = gradient;
            document.querySelector("#sticky").style.backgroundImage = gradient;
            
            let measure = document.querySelector("#skillContainer").offsetHeight;
            document.querySelector("#sticky").style.backgroundSize = `100% ${measure}px`;
          })
        }, 500);
      }, 
      catchReady(evt) {
        if(evt && this.fetchErr) {
          evt(this.fetchErr.message , this.fetchErr.name);
        }
      },
      langFilter(key) {
        
        if(typeof(key) == "object") {
          return [key.icon, key.name];
        }

        let filter = this.skillset.lang.filter(lg => lg[3] == key);
        if(filter.length) {
          return filter[0];
        }
        return [];
      },
      toolFilter(key) {
        let filter = this.skillset.known.filter(tool => tool[3].split(",").includes(key));
        return filter;
      },
      showStickyShadow() {
        document.querySelector("#sticky").style.boxShadow = '0px 7px 8px #00000055'
      },
      hideStickyShadow() {
        document.querySelector("#sticky").style.boxShadow = '0px 0px 0px #00000000'
      },
      thisOnScroll() {
        let sticky = document.querySelector("#sticky");
        let content = document.querySelector("#xp");

        if(!content || !sticky) return;

        if(window.pageYOffset > (content.offsetTop - sticky.offsetHeight)) {
          this.showStickyShadow();
        }
        else {
          this.hideStickyShadow();
        }
      },
      meshApply() {
        queryPalette.generatePalette().then((Palette) => {
          document.querySelector("#skillContainer").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
          document.querySelector("#skillContainer").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
          document.querySelector("#skillContainer").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
        });
      },
      initSlide() {
        if(!this.projects.length) return;

        let sliderCont = this.$refs.slideCnt;
        let positionCont = this.$refs.positions;

        let prjCollection = sliderCont.getElementsByClassName('prj');
        
        for(let projectDiv of prjCollection) {
          projectDiv.style.display = 'none';
        }

        sliderCont.getElementsByClassName('prj-0')[0].style.display = 'flex';
        positionCont.getElementsByClassName(`sp-0`)[0].classList.add("select");

      },
      slideStep(step, animation) {
        if(!this.projects.length) return;

        let max = this.projects.length - 1;
        let nextStep = this.slidePos + (step);

        if(nextStep < 0 || nextStep > max) return;

        let sliderCont = this.$refs.slideCnt;
        let positionCont = this.$refs.positions;
        
        let beforeStep = this.slidePos;
        this.slidePos = nextStep;

        sliderCont.getElementsByClassName(`prj-${beforeStep}`)[0].style.display = "none";
        positionCont.getElementsByClassName(`sp-${beforeStep}`)[0].classList.remove("select");

        sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].classList.add(animation);
        sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].style.display = "flex";
        positionCont.getElementsByClassName(`sp-${nextStep}`)[0].classList.add("select");

        setTimeout(() => {
          sliderCont.getElementsByClassName(`prj-${nextStep}`)[0].classList.remove(animation)
        }, 410)

      }
    },

    mounted() {
      this.loading = true;
      this.getAbility();

      window.addEventListener("scroll", this.thisOnScroll);
    },

    created() {
      this.loadingSkill = true;
      this.getSkillByPart("technical", "skillset");
    },

    unmounted() {
      window.removeEventListener("scroll", this.thisOnScroll);
    }
  };
</script>
  
<style scoped lang="scss">
  @media (prefers-color-scheme: dark) {
    #sticky {
      background: #d1d1d1;
    }
    h1 {
      color: #fff;
    }
    
    h1::after {
      border-bottom: 3px solid #fff;
    }
    #skillContainer {
      background-color: #d1d1d1;
    }
  }

  @media (prefers-color-scheme: light) {
    #sticky {
      background: #fff;
    }
    h1 {
      color: #000;
    }
    
    h1::after {
      border-bottom: 3px solid #000;
    }
    #skillContainer {
      background-color: #fff;
    }
  }

  #topBlur {
    opacity: 0;
    width: 100vw;
    height: 90vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 0;
    transition: opacity 1s;
  }

  #sticky {
    padding: 0 0 10px 0;
    position: sticky;
    top: 59px;
    z-index: 10;
    width: 100%;
    transition: .4s;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 0;

      #themeImg {
        height: 100px;
        width: 100px;
        object-fit: scale-down;
        margin: 0 15px 0 0;
        border-radius: 50%;
      }

      h2 {
        font-size: 52px;
        color: #000;
      }
      
    }
  }

  h1 {
    letter-spacing: 3px;
    text-align: center;
    width: 100%;
    cursor: default;
    z-index: 10;
    transition: .4s;
    margin-bottom: 45px;
    margin-top: 25px;
  }
  
  h1::after {
    content: "";
    display: block;
    margin: 0 auto;
    width: 280px;
    margin-top: 5px;
  }

  h2 {
    font-size: 2em;
    letter-spacing: 1px;
    color: #000;
  }
  
  .skillset {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    margin: 0px auto 0 auto;
  
    max-width: 1366px;
    padding-top: 50px;

    cursor: default;
    min-height: 100vh;
  }
  
  #skillContainer {
    min-height: 575px;
    width: 100%;
    transition: .4s;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    z-index: 5;
    margin: 0 5px;

    transition: opacity 5s;
    color: #000;

    .longExp {
      padding: 20px 100px;

      p {
        text-align: justify;
        padding: 10px 0;
        line-height: 23px;
      }
    }

    .projects {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 30px;
      .sliderCont {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 85%;
        min-height: 30vh;
        padding-top: 20px;

        .slide {
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          width: 100%;
          min-height: 650px;
        }

        .pointer {
          margin: 0 20px;
          opacity: .4;
          transition: opacity .2s;
          span {
            font-family: monospace;
            font-size: 80px;
            user-select: none;
            transition: opacity .2s;
            cursor: pointer;
            transition: color .3s;
            &:active {
              color: rgba(255, 255, 255, 0.3);
            }
          }
          &:hover {
            opacity: 1;
          }
        }
      }
      .slidePosition {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0 0 0;
        padding: 0px 10px;
        height: 30px;
        span {
          min-width: 10px;
          min-height: 10px;
          margin: 5px 8px;
          background: radial-gradient(transparent, #000);
          border-radius: 50%;
          opacity: .6;
          box-shadow: 0px 0px 3px #000;
          transition: all .2s;
        }
        .select {
          min-width: 13px;
          min-height: 13px;
          opacity: 1;
          background: #000;
        }
      }
    }
  }

  .spinerParent {
    margin: auto 0 auto 0;
  }
    
  .tooling {
    width: 100%;
    .toolcont {
      margin-top: 15px;
      padding-bottom: 35px;
      min-width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .ecosys {
        width: 30%;
        min-width: 300px;
        margin: 10px;
        padding: 15px;
        display: inline-table;
        background-color: rgba(73, 73, 73, 0.15);
        box-shadow: 0px 0px 5px #353535ab;
        -webkit-backdrop-filter: blur(6.2px);
        backdrop-filter: blur(6.2px);

        .header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          img {
            height: 80px;
            width: 80px;
            margin: 5px 15px 5px 5px;
          }

          h3 {
            font-size: 23px;
          }
        }

        .body {

          .tools  {
            margin: 10px 0 0 0;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;

            .tools_tool{
              min-width: 150px;
              max-width: auto;
              display: flex;
              align-items: center;

              margin: 6px 6px;
              padding: 7px 10px 10px 5px;
              max-height: 27px;
              overflow: hidden;
              background-color: rgba(255, 255, 255, 0.45);
              box-shadow: 0px 0px 3px #555555ab;

              border-top-left-radius: 3px;
              border-top-right-radius: 3px;
              border-bottom-left-radius: 3px;
              border-bottom-right-radius: 3px;

              img {
                height: 30px;
                width: auto;
                grid-area: ga1;
                object-fit: scale-down;
                margin: auto 15px auto 10px;
              }

              p {
                grid-area: ga2;
                white-space: nowrap;
                font-weight: bold;
                font-size: 14px;
                margin: 0;
              }

            }
          }
        }
      }
    }
  } 

  .animteRightToLeft {
    animation-name: moveRightToLeft;
    animation-duration: .4s;
  }

  .animteLeftToRight {
    animation-name: moveLeftToRight;
    animation-duration: .4s;
  }

  @keyframes moveRightToLeft {
    0% {
      transform: translateX(150%);
      opacity: 0;
    }
    100% {
      transform: translateX(0%);
      opacity: 1;
    }
  }

  @keyframes moveLeftToRight {
    0% {
      transform: translateX(-150%);
      opacity: 0;
    }
    100% {
      transform: translateX(0%);
      opacity: 1;
    }
  }

  @media screen and (max-width: 1050px) {
    #sticky {
      top: 0px;
      div {
        #themeImg {
          margin: 0 25px;
        }
        h2 {
          font-size: 52px;
          text-align: left;
        }
      }

      p {
        margin: 0 15px;
      }
    }


    #skillContainer {
      .projects {
        .sliderCont {
          display: grid;
          grid-template-rows: 2;
          grid-template-columns: 2;
          grid-template-areas: 'con1 con2'
                               'slide slide';
          padding: 0;
          .slide {
            grid-area: slide;
            min-height: unset;
          }

          .p1 {
            grid-area: con1;
          }

          .p2 {
            grid-area: con2;
          }
        }
      }

      
      .longExp {
        padding: 20px 60px;
      }
    }
  }
  
  @media screen and (max-width: 780px) {
    .skillset {
      height: auto;
      margin: 0 auto 0 auto;
      padding-top: 5px;
    }
  
    h1 {
      letter-spacing: 3px;
      padding-top: 0px;
      text-align: center;
      width: 100%;
      top: 0;
      cursor: default;
    }
  
    h2 {
      font-size: 1.6em;
      letter-spacing: 2px;
    }
  }
  
  @media screen and (max-width: 655px) {
    .skillset {
      height: auto;
    }
  
    h1 {
      letter-spacing: 3px;
      padding-top: 0px;
      text-align: center;
      width: 100%;
      top: 0;
      cursor: default;
    }
  
    h2 {
      font-size: 1.45em;
      letter-spacing: 2px;
      padding-left: 3px;
    }
  }
  
  @media screen and (max-width: 495px) {
    .skillset {
      height: auto;
    }
  
    h1 {
      padding-top: 0px;
      font-size: 39px;
    }
  
    h2 {
      font-size: 1.41em;
      letter-spacing: 1.8px;
    }

    #sticky {
      div {
        h2 {
          font-size: 30px;
          text-align: left;
        }
      }
      p {
        font-size: 14px;
      }
    }

    #skillContainer {   
      .longExp {
        padding: 20px;
      }
    }
  }
  
  @media screen and (max-width: 425px) {
    h1 {
      top: 0;
      font-size: 32px;
    }
  
    h2 {
      font-size: 1.25em;
      letter-spacing: 1.8px;
    }
  }
  
  @media screen and (max-width: 400px) {
    h1 {
      cursor: default;
      padding-top: 0px;
      text-align: center;
      width: 100%;
      top: 0;
      letter-spacing: 3px;
      font-size: 34px;
    }
  }
  
  @media screen and (max-width: 380px) {

    h1 {
      cursor: default;
  
      padding-top: 0px;
      text-align: center;
      width: 100%;
  
      top: 0;
      letter-spacing: 3px;
      font-size: 31.5px;
    }
  
    h2 {
      font-size: 1.14em;
      letter-spacing: 1.8px;
    }
  }

</style>